import React from 'react';
import { Workout } from './Workout';
import Canvas from '../components/Canvas';
import { ColorProvider } from './IntervalColors';

interface WorkoutOverviewProps {
    workout: Workout;
}

const colorProvider = new ColorProvider();

const WorkoutOverview: React.FC<WorkoutOverviewProps> = props => {
    //console.log("WorkoutOverview", props.workout);
    return (
        <div>
            <Canvas draw={context => {
                const cw = context.canvas.width;
                const ch = context.canvas.height;

                const ts = props.workout.Intervals.map(i => i.TotalSeconds).reduce((sum, i) => sum + i);
                const maxPower = props.workout.Intervals.map(i => i.TargetPower ?? 0).reduce((max, i) => Math.max(max, i));

                context.clearRect(0, 0, cw, ch);
                const gap = cw / 150;
                const totalGap = gap * (props.workout.Intervals.length - 1);
                const cornerRadius = cw / 75;

                let x = 0;

                for (let i = 0; i < props.workout.Intervals.length; i++)
                {
                    const interval = props.workout.Intervals[i];
                    
                    const intervalWidth = interval.TotalSeconds / ts * (cw - totalGap);
                    
                    if (interval.TargetPower)
                    {
                        const intervalHeight = ch * interval.TargetPower / maxPower;
                        
                        context.fillStyle = colorProvider.getIntervalColor(interval);
                        context.beginPath();
                        context.roundRect(x, ch - intervalHeight, intervalWidth, intervalHeight, cornerRadius);
                        context.fill();
                    }
                    else if (interval.TargetPowerVariation)
                    {
                        const yl = ch * interval.TargetPowerVariation[0] / maxPower;
                        const y2 = ch * interval.TargetPowerVariation[1] / maxPower;
                        const x1 = x;
                        const x2 = x + intervalWidth;
                        const r = cornerRadius;

                        context.beginPath();

                        context.moveTo(x1, ch - r);
                        context.lineTo(x1, ch - yl);

                        context.lineTo(x2, ch - y2);

                        context.lineTo(x2, ch - r);
                        context.arcTo(x2, ch, x2 - r, ch, r);

                        context.lineTo(x1 + r, ch);
                        context.arcTo(x1, ch, x1, ch - r, r);

                        context.fillStyle = colorProvider.getIntervalColor(interval);
                        context.strokeStyle = colorProvider.getIntervalColor(interval);
                        context.fill();
                    }

                    x += intervalWidth + gap;
                }
            }}
            />
        </div>
    );
};

export default WorkoutOverview;
